import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _PropTypes from 'prop-types';
import * as React from 'react';
import { isBoolean } from '../../utils/lang.js';
import { bindRefs } from '../../utils/react.js';
import { Popper } from '../Popper/Popper.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["renderContent", "renderTrigger", "showing", "onOutsideClick", "position"];

var DropdownBase = function DropdownBase(props) {
  props.renderContent;
      props.renderTrigger;
      var showing = props.showing,
      onOutsideClick = props.onOutsideClick,
      position = props.position,
      rest = _objectWithoutProperties(props, _excluded);

  var _React$useState = React.useState(!!showing),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      showingState = _React$useState2[0],
      setShowingState = _React$useState2[1];

  var triggerRef = React.useRef();
  var contentRef = React.useRef();
  React.useEffect(function () {
    var nextOpenState = isBoolean(showing) ? showing : showingState;
    setShowingState(!!nextOpenState);
  }, [showing, showingState, setShowingState]);
  React.useEffect(function () {
    var handleOutsideClick = function handleOutsideClick(e) {
      if (triggerRef.current && triggerRef.current.contains(e.target)) return;
      if (contentRef.current && contentRef.current.contains(e.target)) return;
      if (!isBoolean(showing)) setShowingState(false);
      if (onOutsideClick) onOutsideClick();
    };

    document.addEventListener("click", handleOutsideClick, true);
    return function () {
      document.removeEventListener("click", handleOutsideClick, true);
    };
  }, [onOutsideClick, showing]);

  var toggleDropdown = function toggleDropdown() {
    if (!isBoolean(showing)) setShowingState(!showingState);
  };

  return /*#__PURE__*/jsx(Popper, _objectSpread(_objectSpread({}, rest), {}, {
    showing: showingState,
    transitionProps: "slide",
    placement: position === "left" ? "bottom-end" : "bottom-start",
    renderTrigger: function renderTrigger(_ref) {
      var ref = _ref.ref;
      return props.renderTrigger({
        ref: bindRefs(ref, triggerRef),
        showing: showingState,
        toggleDropdown: toggleDropdown
      });
    },
    renderContent: function renderContent(_ref2) {
      var ref = _ref2.ref,
          style = _ref2.style;
      return props.renderContent({
        ref: bindRefs(ref, contentRef),
        style: style,
        toggleDropdown: toggleDropdown,
        triggerRef: triggerRef
      });
    }
  }));
};

DropdownBase.propTypes = {
  "onOutsideClick": _PropTypes.func,
  "position": _PropTypes.oneOf(["left", "right"]),
  "renderContent": _PropTypes.func.isRequired,
  "renderTrigger": _PropTypes.func.isRequired,
  "showing": _PropTypes.bool
};
DropdownBase.displayName = "DropdownBase";

export { DropdownBase };
